import type { CpdVerdictFilter } from '../../../services/reports.service';

/** Estado de los filtros de la pantalla de reportes (strings para inputs; se limpian al pedir). */
export interface ReportFilters {
  from: string; // YYYY-MM-DD
  to: string; // YYYY-MM-DD
  operatorId: string;
  routeGroupId: string;
  cpdVerdict: '' | CpdVerdictFilter;
  hangupCause: string;
  answered: '' | 'true' | 'false';
  billsecMin: string;
  billsecMax: string;
}

export const VERDICT_LABEL: Record<string, string> = {
  human: 'Humano',
  voicemail: 'Buzón',
  unknown: 'Sin veredicto',
  bypass: 'Bypass',
  '': '—'
};

export const fmtDateTime = (iso: string | null | undefined) =>
  iso
    ? new Date(iso).toLocaleString('es-MX', {
        day: '2-digit',
        month: 'short',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      })
    : '—';

export const fmtSecs = (s: number | null | undefined) => {
  if (s === null || s === undefined) return '—';
  const m = Math.floor(s / 60);
  const r = s % 60;
  return m ? `${m}m ${r}s` : `${r}s`;
};

export { num, pct, pctRate } from '../../../components/utils/format';
